<template>
  <div class="build views"
       :style="viewStyle">
    <!-- 开启全屏按钮 -->
    <div class="fullscreenBtn" v-if="showBtn">
     <i class="el-icon-full-screen icon" @click="fullscreenToggel"></i>
    </div>
    <container :id="id"
               :target="target"
               :option="option"
               ref="container"></container>
  </div>
</template>
<script>
import init from '@smallwei/avue-data/mixins/'
import {listenfullscreen} from '@/components/fullscreen/util.js'

export default {
  props: {
    target: String,
    option: Object,
    id: [String, Number]
  },
  mixins: [init],
  data () {
    return {
      viewStyle: {},
      showBtn: true,
    }
  },

  computed: {
    // 浏览器判断是否全屏
    fullscreenEnable(){
      return document.isFullScreen || document.mozIsFullScreen || document.webkitIsFullScreen
    },
  },

  mounted() {
    listenfullscreen(this.setScreen);
  },

  methods: {
    setScreen() {
      this.showBtn = !this.showBtn;
    },


    fullscreenToggel(){
      if (this.fullscreenEnable) {
        this.exitFullScreen();
      } else {
        this.reqFullScreen();
      };
    },

    // 浏览器退出全屏
    exitFullScreen(){
      if (document.documentElement.requestFullScreen) {
        document.exitFullScreen()
      } else if (document.documentElement.webkitRequestFullScreen) {
        document.webkitCancelFullScreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.mozCancelFullScreen()
      }
    },

    // 浏览器全屏
    reqFullScreen(){
      if (document.documentElement.requestFullScreen) {
        document.documentElement.requestFullScreen()
      } else if (document.documentElement.webkitRequestFullScreen) {
        document.documentElement.webkitRequestFullScreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.fullscreenBtn {
  position: fixed;
  top: 50%;
  right: 5px;
  // top: 10px;
  // right: 10px;
  background: #000000;
  padding: 5px;
  color: #fff !important;
  width: 20px;
  height: 20px;
  border-radius: 10%;
  z-index: 999;
  .icon {
    font-size: 18px;
    cursor: pointer;
  }
}
</style>